import { jsx } from "@emotion/react/jsx-runtime";
import { Pagination as Pagination$1 } from "@mui/material";
import { PaginationItem } from "../PaginationItem/PaginationItem.js";
const Pagination = ({
  color = "primary",
  ...props
}) => {
  return /* @__PURE__ */ jsx(Pagination$1, { renderItem: (item) => /* @__PURE__ */ jsx(PaginationItem, { ...item }), color, ...props });
};
export {
  Pagination
};
//# sourceMappingURL=Pagination.js.map
